import { render, staticRenderFns } from "./1040.vue?vue&type=template&id=03a7045d&scoped=true&lang=html&"
import script from "./1040.vue?vue&type=script&lang=js&"
export * from "./1040.vue?vue&type=script&lang=js&"
import style0 from "./1040.vue?vue&type=style&index=0&id=03a7045d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a7045d",
  null
  
)

export default component.exports